"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 18/01/2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * PromoDistributionModelConverter.
 *
 * @author ZSr
 */


var PromoDistributionModelConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromoDistributionModelConverter, _DataObjectConverter_);

  function PromoDistributionModelConverter() {
    _classCallCheck(this, PromoDistributionModelConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoDistributionModelConverter).apply(this, arguments));
  }

  return PromoDistributionModelConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromoDistributionModelConverter = PromoDistributionModelConverter;